export const enum ARTICLE_ACTIONS {
  REMOVE_BOOKMARK = 'remove_bookmark',
  BOOKMARK = 'bookmark',
  EDIT = 'edit',
  SHARE = 'share',
  PRINT = 'print',
  DOWNLOAD = 'download',
}
